import styled from 'styled-components';

export const ImageBased = styled.figure`
  margin: 0;

  img { width: 100% }
`;

export const Profile = styled(ImageBased)`
  max-width: 200px;
  min-width: 120px;
  width: 100%;
  margin: 0;

  img {
    border-radius: 100px;
    box-shadow: 0px 0px 5px 0px rgba(0,0,0,0.75);
  }

  @media (max-width: 425px) {
    width: 50%;
  }
`;
